/* Progressive enhancement only. The nav is a <details> element, so it already
   works with JavaScript disabled. This just adds the niceties. */
(function () {
  var nav = document.querySelector('[data-nav-mobile]');
  if (!nav) return;

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && nav.open) {
      nav.open = false;
      nav.querySelector('summary').focus();
    }
  });

  document.addEventListener('click', function (event) {
    if (nav.open && !nav.contains(event.target)) {
      nav.open = false;
    }
  });
})();
